import React from "react";
import Image from "@/components/Atoms/Image";
import { FullBackgroundImage } from "@/components/Molecules/ImageCard";
import HeroFeaturedZoomImage from "./HeroFeaturedZoomImage";
import styles from "./HeroFeaturedGridDesktop.module.scss";

interface HeroFeaturedGridDesktopProps {
  id: string;
  backgroundStyle: React.CSSProperties;
  isContain: boolean;
  overlay: React.ReactNode;
  backgroundHero: React.ReactNode;
  copyCard: React.ReactNode;
  imageColData: any;
  featuredImage: any;
  formColumn?: React.ReactNode;
  textAlignment?: string | null;
  addZoom?: boolean;
  zoomIconColor?: { hex?: string };
  isReducedLayout?: boolean;
}

export default function HeroFeaturedGridDesktop({
  id,
  backgroundStyle,
  isContain,
  overlay,
  backgroundHero,
  copyCard,
  imageColData,
  featuredImage,
  formColumn,
  textAlignment,
  addZoom = false,
  zoomIconColor,
  isReducedLayout = false,
}: HeroFeaturedGridDesktopProps) {
  const isTextColumnRight = textAlignment === "right";
  const showZoom = Boolean(addZoom && featuredImage);
  const useReducedLayout = isReducedLayout || showZoom;

  const copyColumn = <div className={styles.copyCol}>{copyCard}</div>;
  const imageColumn =
    imageColData &&
    (
      <figure
        className={`${styles.imageCol} ${useReducedLayout ? styles.imageColZoom : ""}`}
        aria-hidden={!imageColData}
      >
        {showZoom ? (
          <HeroFeaturedZoomImage
            image={featuredImage}
            iconColor={zoomIconColor}
            imageClassName={`relative mx-auto ${styles.imageAssetZoom}`}
          />
        ) : isContain ? (
          <FullBackgroundImage data={imageColData} position="Contain" />
        ) : (
          featuredImage && (
            <Image
              data={featuredImage}
              className={`relative ${styles.imageAsset}`}
              objectFit="contain"
            />
          )
        )}
      </figure>
    );

  const backgroundLayer = useReducedLayout ? (
    <div className={styles.zoomBackground}>
      {overlay}
      {backgroundHero}
    </div>
  ) : (
    <>
      {overlay}
      {!isContain && backgroundHero}
    </>
  );

  return (
    <div
      className={`${styles.shell} ${useReducedLayout ? styles.shellZoom : ""}`}
      id={id}
      style={backgroundStyle}
    >
      {backgroundLayer}
      <div
        className={`${styles.layout} ${
          formColumn ? "grid grid-cols-1 lg:grid-cols-2" : ""
        }`}
      >
        <div className={styles.grid}>
          {isTextColumnRight ? (
            <>
              {imageColumn}
              {copyColumn}
            </>
          ) : (
            <>
              {copyColumn}
              {imageColumn}
            </>
          )}
        </div>
        {formColumn}
      </div>
    </div>
  );
}
